const basePath = '/pengelolaan-kinerja'

export const PENGELOLAAN_KINERJA_BASE_PATH = basePath

// Beranda
export const PENGELOLAAN_KINERJA_BERANDA_PATH = PENGELOLAAN_KINERJA_BASE_PATH

// Guru
export const PENGELOLAAN_KINERJA_GURU_PATH = `${PENGELOLAAN_KINERJA_BASE_PATH}/guru`

// Kepala Sekolah
export const PENGELOLAAN_KINERJA_KS_PENILAI_PATH = `${PENGELOLAAN_KINERJA_BASE_PATH}/kepala-sekolah/penilai`
export const PENGELOLAAN_KINERJA_KS_PEGAWAI_PATH = `${PENGELOLAAN_KINERJA_BASE_PATH}/kepala-sekolah/pegawai`

// Pamong
export const PENGELOLAAN_KINERJA_PAMONG_PATH = `${PENGELOLAAN_KINERJA_BASE_PATH}/pamong`

// Kepala Sekolah SPNF
export const PENGELOLAAN_KINERJA_KSPNF_PATH = `${PENGELOLAAN_KINERJA_BASE_PATH}/kepala-spnf`
export const PENGELOLAAN_KINERJA_KSPNF_PEGAWAI_PATH = `${PENGELOLAAN_KINERJA_KSPNF_PATH}/pegawai`
export const PENGELOLAAN_KINERJA_KSPNF_PENILAI_PATH = `${PENGELOLAAN_KINERJA_KSPNF_PATH}/penilai`

// Pengawas Sekolah
export const PENGELOLAAN_KINERJA_PS_PATH = `${PENGELOLAAN_KINERJA_BASE_PATH}/pengawas-sekolah`
export const PENGELOLAAN_KINERJA_PS_PEGAWAI_PATH = `${PENGELOLAAN_KINERJA_PS_PATH}/pegawai`
export const PENGELOLAAN_KINERJA_TIM_KINERJA_PS_PATH = `${PENGELOLAAN_KINERJA_BASE_PATH}/tim-kinerja`
export const PENGELOLAAN_KINERJA_PEJABAT_PENILAI_KINERJA_PS_PATH = `${PENGELOLAAN_KINERJA_BASE_PATH}/pejabat-penilai-kinerja`

// Penilik SPNF
export const PENGELOLAAN_KINERJA_PENILIK_PATH = `${PENGELOLAAN_KINERJA_BASE_PATH}/penilik`
export const PENGELOLAAN_KINERJA_PENILIK_PEGAWAI_PATH = `${PENGELOLAAN_KINERJA_PENILIK_PATH}/pegawai`

// Dinas Pendidikan
export const PENGELOLAAN_KINERJA_KADIN_PATH = `${PENGELOLAAN_KINERJA_BASE_PATH}/kepala-dinas`
export const PENGELOLAAN_KINERJA_KADIN_PEMBERI_PREDIKAT_PATH = `${PENGELOLAAN_KINERJA_KADIN_PATH}/pemberi-predikat-kinerja-organisasi`

// Notifikasi
export const PENGELOLAAN_KINERJA_NOTIFIKASI_PATH = `${PENGELOLAAN_KINERJA_BASE_PATH}/notifikasi`

// Riwayat
export const PENGELOLAAN_KINERJA_RIWAYAT_PATH = `${PENGELOLAAN_KINERJA_BASE_PATH}/riwayat`
export const PENGELOLAAN_KINERJA_RIWAYAT_KS_PATH = `${PENGELOLAAN_KINERJA_BASE_PATH}/riwayat/[riwayatId]`
export const PENGELOLAAN_KINERJA_RIWAYAT_KS_V2_PATH = `${PENGELOLAAN_KINERJA_BASE_PATH}/riwayat/ks/[riwayatId]`
export const PENGELOLAAN_KINERJA_RIWAYAT_GURU_PATH = `${PENGELOLAAN_KINERJA_RIWAYAT_PATH}/guru`

// Errors
export const PENGELOLAAN_KINERJA_NOT_FOUND_PATH = `${PENGELOLAAN_KINERJA_BASE_PATH}/404`
